module.exports = __webpack_public_path__ + "static/media/ppt.47347bb7.svg";